import { subtractDays } from '../../utils/functions/common';
import {
  TMVPMapFilters,
  TMVPMapGetFarmDataFilters,
} from '../../types/mvpMap';

export const getFilterDataForMapQueryString = (
  filters: TMVPMapFilters
) => {
  const {
    startTime,
    endTime,
    selectedIndex,
    commonFilters: {
      index,

      region,
      subRegion,
      village,
      regionManager,
      tpm,
      fa,
      organizer,
      cropType,
      hybridType,
      sowingStartDate,
      sowingEndDate,
      season,
      excludeHarvestFlag,
      excludePldFlag,
    },
    filterTypes,
    tableDataType,
    daysAfterPlanting,
    wsId,
  } = filters;
  return `query
            GetDataForTimeRangeWithFilters {
              GetDataForTimeRangeWithFilters(
                input: {
                  wsId: ${wsId || 1}
                  filters: [${filterTypes}]
                  sowingDate: {
                    startTime: { seconds: ${
                      sowingEndDate
                        ? subtractDays(sowingEndDate)
                        : 0
                    } }
                    endTime: { seconds: ${
                      sowingStartDate
                        ? subtractDays(sowingStartDate)
                        : 0
                    } }
                  }
                  indexName: "${selectedIndex || index}"
                  geography: {
                   
                    region: "${region ? region : ''}"
                    subRegion: "${
                      subRegion ? subRegion : ''
                    }"
                    village: "${village ? village : ''}"
                  }
                  peopleId: {
                    regionManagerId: "${
                      regionManager ? regionManager : '0'
                    }"
                    tpmId: "${tpm ? tpm : '0'}"
                    faId: "${fa ? fa : '0'}"
                    organizerId: "${
                      organizer ? organizer : '0'
                    }"
                  }
                  cropName: "${cropType ? cropType : ''}"
                  hybridCode: "${
                    hybridType ? hybridType : ''
                  }"
                  excludeHarvestFlag:${
                    excludeHarvestFlag ?? true
                  }
                  excludePldFlag:${excludePldFlag ?? true}
                  season: "${season == 'ALL' ? '' : season}"
                  ${
                    tableDataType !== undefined
                      ? `tableDataType: ${tableDataType}`
                      : ''
                  },
                  ${
                    daysAfterPlanting !== undefined
                      ? `daysAfterPlanting: ${daysAfterPlanting}`
                      : ''
                  },
                  ${
                    startTime !== undefined &&
                    endTime !== undefined
                      ? ` timeRange: {
                            startTime: { seconds: "${startTime}" }
                            endTime: { seconds: "${endTime}" }
                           }`
                      : ''
                  },
                }
              ) {
                responseStatus {
                  status
                  statusReason
                  errorCode
                  reasons
                  errorMessages
                  internalErrorCode
                }
                fieldNumbers
                dates
                dateFieldsJson
              }
            }`;
};

export const getFieldDataForFieldNosQueryString = (
  filters: TMVPMapGetFarmDataFilters
) => {
  const {
    startTime,
    endTime,
    commonFilters: { index },
    fieldNumbers,
    tableDataType,
    daysAfterPlanting,
    selectedIndex,
    wsId,
  } = filters;
  return `query
            GetFieldDataForFieldNos {
              GetFieldDataForFieldNos(
                input: {
                  wsId: ${wsId || 1}
                  fieldNumbers: [
                    ${fieldNumbers}
                  ]
                  indexName: "${selectedIndex || index}"
                  ${
                    tableDataType !== undefined
                      ? `tableDataType: ${tableDataType}`
                      : ''
                  },
                  ${
                    daysAfterPlanting !== undefined
                      ? `daysAfterPlanting: ${daysAfterPlanting}`
                      : ''
                  },
                  ${
                    startTime !== undefined &&
                    endTime !== undefined
                      ? ` timeRange: {
                            startTime: { seconds: "${startTime}" }
                            endTime: { seconds: "${endTime}" }
                           }`
                      : ''
                  },
                }
              ) {
                responseStatus {
                  status
                  statusReason
                  errorCode
                  reasons
                  errorMessages
                  internalErrorCode
                }
                fieldDataList {
                  fieldNumber
                  fieldDetails {
                    registeredArea
                    geofenceArea
                    areaUnderReported
                    growerName
                    hybridCode
                    lotNo
                    sowingTime{
                      seconds
                    }
                    harvestTime{
                      seconds
                    }
                    crop
                    # fieldTags {
                    #   fieldTagName
                    #   fieldTagValue {
                    #     fieldTagValueType
                    #     doubleValues
                    #     stringValues
                    #     boolValues
                    #     int64Values
                    #     int32Values
                    #   }
                    # }
                    employeeData {
                      regionManager
                      tpm
                      fa
                      organizer
                    }
                    geographyData {
                      region
                      # subRegion
                      village
                    }
                  }
                  fieldGeomData {
                    geometry
                    # centerLat
                    # centerLon
                  }
                  fieldIndexList {
                    presignedS3TiffUrl
                    indexName
                    # minIndex
                    # maxIndex
                    averageIndex
                    # standardDeviation
                    cloudCoverPercentage
                    indexTime {
                      seconds
                      nanos
                    }
                  }
                }
              }
            }`;
};
